module.exports = __webpack_public_path__ + "img/fashion_83.c39cf13f.jpg";